module.exports = __webpack_public_path__ + "img/2.ec257e74.svg";